import React, { useCallback, useEffect, useState } from "react";

import Api from "src/services/api";

import { PapiroConsole } from "src/utils/papiroConsole";

import { styled } from "@mui/styles";
import { Grid, Skeleton, Tooltip, Typography } from "@mui/material";
import FooterExternalSkeleton from "./footer-external-skeleton";

import { faFacebook, faInstagram, faLinkedin, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import "./footer.css"

let channelWebchat = {}

const FooterImage = styled("img")(({ isLoaded }) => ({
    maxWidth: "250px",
    maxHeight: "120px",
    objectFit: 'contain',
    objectPosition: "center",
    opacity: isLoaded ? 1 : 0,
    transition: "opacity 0.3s ease-in-out",
}));

const Footer = (props) => {

    const { intl, clientportal, setLoading, loading } = props
    const [src, setSrc] = useState('')
    //const [channelWebchat, setChannelWebchat] = useState({})
    const [isLoadedFooterImage, setIsLoadedFooterImage] = useState(false);

    const footerImage = clientportal?.footerimage;
    const footerImageDescription = footerImage && footerImage?.description ? footerImage.description : "Footer Image";

    const getFile = async (image) => {

        try {
            const response = await fetch(image.anonymoustoken)

            if (!response.ok) {
                throw new Error('Erro ao buscar o link da imagem')
            }

            const json = await response.json()

            if (json?.data) {
                const imageUrl = json.data
                setSrc(imageUrl)
            }
        } catch (e) {
            PapiroConsole.log('Erro ao carregar imagem do footer')
            PapiroConsole.log(e)
        }
    }

    const handleLoad = useCallback(() => {
        setIsLoadedFooterImage(true);
    }, []);

    useEffect(async () => {
        if (clientportal.footerimage) {
            getFile(clientportal.footerimage)
        }
    }, [clientportal])

    useEffect(async () => {
        if (clientportal.enablewebchat && (!channelWebchat.token || !channelWebchat.scriptname)) {
            await getWebchat()
            await showChatConfigMount()
        }
    }, [clientportal])

    const getWebchat = async () => {

        await Api.get(`/twotalkchannelwebchat/external/hirer/${clientportal.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    channelWebchat = result.data.data
                    //setChannelWebchat(result.data.data)
                } else {
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                Api.kickoff(err)
            })
    }

    const ApplyWebchat = (REACT_APP_URL, _2talk_options) => {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
            REACT_APP_URL = 'https://dev.webchat.mexx.ai:3000/'
        }
        var _2talk_root_div = document.getElementById('2talk')
        if (_2talk_root_div == null) {
            _2talk_root_div = document.createElement('div')
            _2talk_root_div.setAttribute('id', '2talk')
            document.body.appendChild(_2talk_root_div)

        }

        if (_2talk_root_div != null) {
            var _2talk_link = document.getElementById('2talk_css')
            if (_2talk_link != null) {
                document.head.removeChild(_2talk_link)
            }
            var _2talk_root_script = document.getElementById('2talk_script')
            if (_2talk_root_script != null) {
                document.head.removeChild(_2talk_root_script)
            }
        }

        window._2talk_chatclientkey = _2talk_options._2talk_chatclientkey;

        var _2talk_root_script = document.createElement('script');
        _2talk_root_script.setAttribute('src', REACT_APP_URL + 'build/static/js/main.js');
        _2talk_root_script.setAttribute('defer', 'defer');
        _2talk_root_script.setAttribute('id', '2talk_script');
        document.head.appendChild(_2talk_root_script);

        var _2talk_link = document.createElement('link');
        _2talk_link.setAttribute('href', REACT_APP_URL + 'build/static/css/main.css');
        _2talk_link.setAttribute('rel', 'stylesheet');
        _2talk_link.setAttribute('id', '2talk_css');
        document.head.appendChild(_2talk_link);
    }

    const showChatConfigMount = async () => {
        try {
            PapiroConsole.log('try')
            PapiroConsole.log(channelWebchat.scriptname)
            PapiroConsole.log(channelWebchat.token)
            if (channelWebchat.scriptname && channelWebchat.token) {
                PapiroConsole.log('try if')
                if (document.getElementById("script_webchat_2talk") == null) {
                    PapiroConsole.log('try element null')
                    var txtscript = 'var _2talk_chatclientkey = "' + channelWebchat.token + '";'
                    let scriptvar = document.createElement("script")
                    scriptvar.id = "script_webchat_2talk"
                    scriptvar.async = false
                    scriptvar.append(txtscript)
                    document.body.appendChild(scriptvar)

                    localStorage.setItem('_2talk_chatclientkey', channelWebchat.token);

                    if (channelWebchat.token) {
                        var _2talk_options = {
                            _2talk_mail: null, _2talk_customer_name: null, _2talk_customer_mail: null,
                            _2talk_customer_phone: null, _2talk_external_application_id: null
                        }

                        _2talk_options._2talk_chatclientkey = channelWebchat.token;

                        ApplyWebchat(channelWebchat.scriptname.replace('2talk-widget.js', ''), _2talk_options)
                    }
                }
            }

            // if (orgData == null || (orgData && orgData.length == 0)) {
            //     let response = await getOrganizations();
            //     if (response && response.data)
            //         orgData = response.data
            // }
            // orgData = orgData.filter(c => c.active == true)

            // PapiroConsole.log(orgData)
            // PapiroConsole.log("orgData aqui")

            // this.setState({ orgList: orgData && orgData.length > 1 ? orgData.sort((a, b) => a.name.localeCompare(b.name)) : orgData, showDialog: true })

            // for (let item of orgData) {
            //     if (item.organizationsettings) {
            //         if (item.organizationsettings.allowattendanceviachat) {
            //             this.setState({ showChatButton: true });
            //             this.setState({ showChatConfig: this.isClient ? false : true });
            //             return
            //         }
            //     }
            // }

        } catch (err) {
            PapiroConsole.log('err')
            PapiroConsole.log(err)
        }
    }

    if (loading) {
        return <FooterExternalSkeleton />;
    }

    return (
        <Grid item container direction="row" spacing={2} px="20vw" py="10px" marginTop={0} justifyContent="space-between" alignItems="center"
            style={{
                paddingInline: "20vw",
                paddingBlock: "10px",
                backgroundColor: "#f1f3f4",
                borderTop: "1px solid #E7E7E7",
                textAlign: "center",
            }}>
            <Grid container item sm={9} spacing={2} direction="column" >
                {footerImage && !!src && (
                    <Grid item textAlign='start' position={"relative"} width={"fit-content"} pt={0}>
                        {!isLoadedFooterImage && (
                            <Skeleton
                                variant="rectangular"
                                width={"250px"}
                                height={"50px"}
                                sx={{ borderRadius: 1, position: "absolute" }}
                            />
                        )}

                        <FooterImage
                            src={src}
                            alt={footerImageDescription}
                            loading="lazy"
                            decoding="async"
                            isLoaded={isLoadedFooterImage}
                            onLoad={handleLoad}
                        />
                    </Grid>
                )}
                <Grid container item sm={6} spacing={4} direction="row" >
                    {
                        clientportal.footertext &&
                        <Grid item pt={0}>
                            <Typography>{clientportal.footertext}</Typography>
                        </Grid>
                    }
                    {
                        clientportal.footerphone &&
                        <Grid item pt={0}>
                            <Typography>{clientportal.footerphone}</Typography>
                        </Grid>
                    }
                    {
                        clientportal.footeremail &&
                        <Grid item pt={0}>
                            <Typography>{clientportal.footeremail}</Typography>
                        </Grid>
                    }
                </Grid>
            </Grid>
            <Grid container item sm={2} direction="row" justifyContent="end" spacing={2} >
                {
                    clientportal.showfacebook && clientportal.facebooklink &&
                    <Grid item sm={3}>
                        <Tooltip title={<h5>Facebbook</h5>} color="secondary" style={{ cursor: "pointer" }}>
                            <FontAwesomeIcon icon={faFacebook} className="footerIcon" onClick={_ => window.open(clientportal.facebooklink, "_blank")} />
                        </Tooltip>
                    </Grid>
                }
                {
                    clientportal.showinstagram && clientportal.instagramlink &&
                    <Grid item sm={3} >
                        <Tooltip title={<h5>Instagram</h5>} color="secondary" style={{ cursor: "pointer" }}>
                            <FontAwesomeIcon icon={faInstagram} className="footerIcon" onClick={_ => window.open(clientportal.instagramlink, "_blank")} />
                        </Tooltip>
                    </Grid>
                }
                {
                    clientportal.showyoutube && clientportal.youtubelink &&
                    <Grid item sm={3}>
                        <Tooltip title={<h5>Youtube</h5>} color="secondary" style={{ cursor: "pointer" }}>
                            <FontAwesomeIcon icon={faYoutube} className="footerIcon" onClick={_ => window.open(clientportal.youtubelink, "_blank")} />
                        </Tooltip>
                    </Grid>
                }
                {
                    clientportal.showlinkedin && clientportal.linkedinlink &&
                    <Grid item sm={3}>
                        <Tooltip title={<h5>Linkedin</h5>} color="secondary" style={{ cursor: "pointer" }}>
                            <FontAwesomeIcon icon={faLinkedin} className="footerIcon" onClick={_ => window.open(clientportal.linkedinlink, "_blank")} />
                        </Tooltip>
                    </Grid>
                }
            </Grid>
        </Grid>
    )
}

export default Footer